<div class="modal-body">
    {{caption}}
</div>